/* Local dependencies */
import { SessionUser } from "../dashboard/auth/redux/auth-actions";
import * as roles from './roles';
import { UserRole } from './roles';

export function getUserRole(currentUser: SessionUser) {
  if (!currentUser?.roles && currentUser?.hasOwnProperty('cognito:preferred_role')) {
    currentUser.roles = roles.extractRoleFromARN(currentUser['cognito:preferred_role']);
  }

  return currentUser?.roles;
}

export function getCurrentUserRole(currentUser: SessionUser): UserRole {
  const role = currentUser?.['cognito:groups']?.[0];

  if (role === UserRole.ADMIN) return UserRole.ADMIN;
  if (role === UserRole.MANAGER) return UserRole.MANAGER;
  if (role === UserRole.USER) return UserRole.USER;
}

export function isAdmin(currentUser: SessionUser): boolean {
  return getCurrentUserRole(currentUser) === UserRole.ADMIN;
}

export function isManager(currentUser: SessionUser): boolean {
  return getCurrentUserRole(currentUser) === UserRole.MANAGER;
}

export function isAdminOrManager(currentUser: SessionUser): boolean {
  const role = getCurrentUserRole(currentUser);

  return role === UserRole.ADMIN || role === UserRole.MANAGER;
}

export function getItemFromLocalStorage(key: string): string | null {
  if (typeof window === 'undefined') {
    return null;
  }
  
  return localStorage.getItem(key);
}

export function setItemToLocalStorage(key: string, value: string): void {
  if (typeof window === 'undefined') {
    return;
  }
  
  localStorage.setItem(key, value);
}

export function removeItemFromLocalStorage(key: string): void {
  if (typeof window === 'undefined') {
    return;
  }

  localStorage.removeItem(key);
}

export function formatPrice(price: string): { dollars: string; cents: string } {
  const parts = price.split('.');

  return {
    dollars: parts[0],
    cents: parts[1] ? `.${parts[1]}` : '',
  };
}

export function formatTimestamp(timestamp?: number): string {
  if (!timestamp) {
    return '-';
  }

  return new Intl.DateTimeFormat(undefined, {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(new Date(timestamp * 1000));
}

export function getFullName(user) {
  const { firstName, lastName } = user || {};

  return `${firstName || ''} ${lastName || ''}`.trim();
}

export function getInitials(user) {
  const { firstName, lastName } = user || {};

  return `${firstName?.charAt(0).toUpperCase() || ''}${lastName?.charAt(0).toUpperCase() || ''}`;
}

export function copyToClipboard(text: string): Promise<void> {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    return navigator.clipboard.writeText(text);
  } else {
    const textArea = document.createElement('textarea');
    
    textArea.value = text;
    textArea.style.position = 'fixed';
    textArea.style.left = '-999999px';
    textArea.style.top = '-999999px';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    
    return new Promise<void>((resolve, reject) => {
      try {
        document.execCommand('copy');
        textArea.remove();
        resolve();
      } catch (err) {
        textArea.remove();
        reject(err);
      }
    });
  }
}
